import React, { useState } from "react";
import { Accordion, Row, Col, Button } from "react-bootstrap";
import TopNav from "../../TopNav/TopNav";
import JobNav from "../JobNav";
import JobGeneralOverview from "../JobOverviewBar";
import { useDispatch, useSelector } from "react-redux";
//import { fetchTableIds } from "../../../redux/slices/tableIdSlice";
//import { fetchZones } from "../../../redux/slices/zoneCountSlice";
import { selectApiUrls } from "../../../redux/slices/apiUrlSlice"; // Import the selector
import { selectUserDetails } from "../../../redux/slices/userSlice";
import CheckoutNotification from "../checkoutNotification";
import CreateZoneButton from "../CreateZoneButton";
import { setSelectedZone } from "../../../redux/slices/activeMechanicalTabSlice";
import { selectGeneralProject, selectGeneralStation } from "../../../redux/selectors";
import useCriticalData from "../../../functions/useCriticalData";

import JobGeneralProjectInfoRF from "./JobGeneralProjectInfoRF";
import JobGeneralSpecsRF from "./JobGeneralSpecsRF";
import useJobHandler from "../../../functions/JobHandler"; // Import the useJobHandler function

function JobGeneralInfo() {
  // Fetch the current user from the Redux store
  const currentKey = "generalInfo";
  const userDetails = useSelector(selectUserDetails); // User details
  const currentUser = userDetails?.name;

  // JobHandler manages all job loading, checkout, and data fetching
  useJobHandler();
  
  const jobId = useSelector((state) => state.jobId.jobId); // Fetch jobId from redux
  const tbdForms = useSelector((state) => state.tbd?.forms || {});
  const apiUrls = useSelector(selectApiUrls); // Fetch API URLs from Redux

  const dispatch = useDispatch();

  // Load critical data including dropdown values
  // Force refresh to ensure we get updated dropdown values after admin changes
  useCriticalData({
    apiKeys: ['dropdownValues'],
    autoLoad: true,
    forceRefresh: false // Will fetch if not cached or cache is expired
  });

  const generalProjectDetails = useSelector(selectGeneralProject);
  const generalSpecsDetails = useSelector(selectGeneralStation);
  const zoneCount = generalProjectDetails[0]?.Zones || 0;
  const createdZones = generalSpecsDetails.length || 0;



  const [activeTab, setActiveTab] = useState("zone1"); // State to handle active tab

  const hasTbdForSection = (section) => {
    if (section === "Project Info") {
      return Boolean(tbdForms.generalProject?.hasTbd);
    }

    if (section === "Station Info") {
      return Boolean(tbdForms.generalStation?.hasTbd);
    }

    return false;
  };

  const handleZoneChange = (zone, zoneNumber) => {
    setActiveTab(zone);
    dispatch(setSelectedZone(zoneNumber));
  };

  return (
    <div className="basic-page">
      <TopNav />
      <JobGeneralOverview />
      <JobNav keyValue={currentKey} />
      <CheckoutNotification currentUser={currentUser} />

      <Accordion alwaysOpen>
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <h3>
              {hasTbdForSection("Project Info") && (
                <i
                  className="bi bi-exclamation-diamond-fill"
                  style={{ color: "red" }}
                />
              )}{" "}
              General Information
            </h3>
          </Accordion.Header>
          <Accordion.Body>
            <JobGeneralProjectInfoRF />
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
          <Accordion.Header>
            <h3>
              {hasTbdForSection("Station Info") && (
                <i
                  className="bi bi-exclamation-diamond-fill"
                  style={{ color: "red" }}
                />
              )}{" "}
              General Specifications
            </h3>
          </Accordion.Header>
          <Accordion.Body>
            <Row className="mb-3">
              <Col>
                <Button
                  variant={activeTab === "zone1" ? "primary" : "secondary"}
                  onClick={() => handleZoneChange("zone1", 1)}
                >
                  Zone 1
                </Button>
                {createdZones > 1 && (
                  <Button
                    variant={activeTab === "zone2" ? "primary" : "secondary"}
                    onClick={() => handleZoneChange("zone2", 2)}
                    className="ms-2"
                  >
                    Zone 2
                  </Button>
                )}
                {zoneCount !== createdZones && (
                  <CreateZoneButton
                    jobId={jobId}
                    apiUrl={apiUrls.generalStation} // Pass the API URL
                    zoneCount={zoneCount}
                    // tableIds={tableIds} // Pass the entire tableIds object
                  />
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                {activeTab === "zone1" && (
                  <>
                    <JobGeneralSpecsRF
                      // tableId={zone1TableId} // Pass the tableId for zone 1
                      zone="1"
                      // onHasTbdChange={handleHasTbdChange}
                    />
                  </>
                )}
                {activeTab === "zone2" && (
                  <JobGeneralSpecsRF
                    // tableId={zone2TableId} // Pass the tableId for zone 2
                    zone="2"
                    // onHasTbdChange={handleHasTbdChange}
                  />
                )}
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}

export default JobGeneralInfo;
